var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveSessionsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4.5h32a1 1 0 0 1 1 1v5.732A8.766 8.766 0 0 0 33 11c-4.746 0-9 3.92-9 8.68 0 2.14 1.097 4.482 2.56 6.82H20l.016 1.992a1 1 0 0 1-1 1.008H17a1 1 0 0 1-1-1v-2H2a1 1 0 0 1-1-1v-20a1 1 0 0 1 1-1zm23 30a3 3 0 0 0-3-3h-8a3 3 0 0 0-3 3v1h14v-1zm15-14.556C40 16.136 36.692 13 33 13c-3.691 0-7 3.136-7 6.944 0 2.799 2.28 6.03 4.36 8.973C31.39 30.378 32.371 31.768 33 33c.629-1.232 1.61-2.622 2.641-4.082C37.719 25.974 40 22.743 40 19.944zM33 17l3 4-3 4-3-4 3-4z",
    fill: "#9A9CAC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveSessionsIcon);
export default __webpack_public_path__ + "static/media/activeSessionsIcon.36f678bf.svg";
export { ForwardRef as ReactComponent };